// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XwkvH","rootNoMargin":"styles_rootNoMargin__2uTU-"};